import {protectedPage} from '@/utils';

import Vue from 'vue'
import VueRouter from 'vue-router'
import Merchant from '../views/merchant/Index.vue'
import Client from '../views/client/Index.vue'
import RecoverPassword from '../views/account/RecoverPassword.vue'
import CreateAccount from '../views/account/CreateAccount.vue'
import AccountValidation from '../views/account/AccountValidation.vue'
import ClientData from '../views/account/ClientData.vue'
import Account from '../views/account/Account.vue'
import AccountResetValidation from '../views/account/AccountResetValidation.vue'
import ConfirmForget from '../views/account/ConfirmForget.vue';
import TermsAndConditions from '../views/TermsAndConditions.vue';
import PrivacyPolicy from '../views/PrivacyPolicy.vue';

Vue.use(VueRouter)

const routes = [
  {
    path: '/',
    name: 'Client',
    component: Client
  },
  {
    path: '/comerciante',
    name: 'Merchant',
    component: Merchant
  },
  {
    path: '/cliente',
    name: 'Client',
    component: Client
  },
  {
    path: '/recuperar-contrasena',
    name: 'RecoverPassword',
    component: RecoverPassword
  },
  {
    path: '/crear-cuenta',
    name: 'CreateAccount',
    component: CreateAccount
  },
  {
    path: '/validar-cuenta',
    name: 'AccountValidation',
    component: AccountValidation
  },
  {
    path: '/validacion-de-restablecimiento-de-cuenta',
    name: 'AccountResetValidation',
    component: AccountResetValidation
  },
  {
    path: '/datos-del-cliente',
    name: 'ClientData',
    component: ClientData
  },
  {
    path: '/confirmar-recuperacion/:token',
    name: 'ConfirmForget',
    component: ConfirmForget
  },
  {
    path: '/cuenta',
    name: 'Account',
    component: Account,
    beforeEnter(to, from, next) {
      protectedPage(to, from, next);
    },
  },
  {
    path: '/terminos-y-condiciones',
    name: 'TermsAndConditions',
    component: TermsAndConditions
  },
  {
    path: '/politica-de-privacidad',
    name: 'PrivacyPolicy',
    component: PrivacyPolicy
  },
]

const router = new VueRouter({
  mode: 'history',
  // base: process.env.BASE_URL,
  routes
})

export default router
